import { useState } from 'react';

/**
 * The "which row is being edited" state machine shared by the Verein/
 * Wettbewerbe/Sportler/Starter list-editor screens. Each view still owns its
 * own `handleAdd`/`handleDelete` bodies — factory calls, cascade-clear
 * logic and toast/confirm copy differ enough per entity that folding those
 * in here would trade real duplication for indirection. This lifts only the
 * one piece that's genuinely identical across all four.
 */
export function useEntityList() {
  const [editing, setEditing] = useState<string | null>(null);

  function startEditing(id: string): void {
    setEditing(id);
  }

  function stopEditing(): void {
    setEditing(null);
  }

  /** Stop editing, but only if `id` is the row currently open — used after
   *  deleting a row, so deleting some *other* row doesn't close the one
   *  actually being edited. */
  function stopEditingIf(id: string): void {
    if (editing === id) setEditing(null);
  }

  return { editing, startEditing, stopEditing, stopEditingIf };
}
